<template>
  <v-dialog :value="isActive" @click:outside="$emit('update:isActive', false)" width="500px">
    <v-card>
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span>Make a transfer</span>
        <v-btn text icon dark @click="$emit('update:isActive', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-container>
        <custom-form
          :fields="paymentType"
          :method="method"
          :action="url"
          @submitted="$emit('changed', $event)"
          @input:amount_without_fees_in_euro="updateFees"
        >
          <v-container>
            <v-row no-gutters>
              <v-col cols="12">
                <custom-user-search
                  name="sender_id"
                  label="Select the sender"
                  item_name="full_name"
                  item_value="id"
                  icon="mdi-account-search"
                  @changed="updateBankAccounts"
                />
              </v-col>
              <v-col cols="12">
                <custom-user-search
                  name="recipient_id"
                  label="Select the receiver"
                  item_name="full_name"
                  item_value="id"
                  icon="mdi-account-search"
                />
              </v-col>
              <v-col cols="12">
                <custom-select
                  name="cashin_method_id"
                  :items="cashin_methods"
                  @changed="handleCashinMethods"
                  label="Select the cashin method"
                />
              </v-col>
              <v-col cols="12">
                <custom-input name="amount_without_fees_in_euro" label="Amount(Euro)" />
              </v-col>

              <v-col cols="12">
                <custom-select
                  name="bank_account_id"
                  :items="user_bank_accounts"
                  item-value="id"
                  item-text="title"
                  label="Select the user Bank Account"
                />
                <div class="mb-6">
                  <span>Fees : €{{ fee }}</span>
                </div>
              </v-col>
              <v-col cols="12">
                <custom-input name="reason" label="Payment reason" />
              </v-col>
              <v-col cols="12">
                <custom-button block color="primary">
                  Confirm
                </custom-button>
              </v-col>
            </v-row>
          </v-container>
        </custom-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isActive: { required: true, type: Boolean },
    method: { default: "post", type: String },
    paymentType: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      selected_cashin_method_id: null,
      fee: 0,
      selected_user: null,
      cashin_methods_data: [],
      user_bank_accounts: [],
      sender_bank_accounts: [],
      //   key: 1,
    };
  },
  computed: {
    url() {
      return "api/v1/payments/initiateFromBackOffice";
    },
    cashin_methods() {
      return this.getSelectOptions(this.cashin_methods_data);
    },
  },
  async created() {
    await this.fetchData();
  },
  watch: {
    // isActive() {
    //   this.key++;
    // },
  },
  methods: {
    getSelectOptions(data) {
      return data.map(({ id, name }) => ({ value: id, text: name }));
    },
    handleCashinMethods(value) {
      this.selected_cashin_method_id = value;
    },
    async updateBankAccounts(user_id) {
      if (user_id !== undefined) {
        await this.$http.get(`/api/v1/users/${user_id}`).then((response) => {
          this.selected_user = response;
        });
        await this.$http.get(`/api/v1/userBankAccounts/all/${user_id}`).then((response) => {
          this.user_bank_accounts = response.data;
        });
      }
    },
    async updateFees(value) {
      await this.$http
        .post(`/api/v1/payments/getEuroAppliedFees/transfer/${this.selected_user.id}`, {
          cashin_method_id: this.selected_cashin_method_id,
          euro_amount: value,
          sending_country_id: this.selected_user.country_id,
        })
        .then((response) => {
          this.fee = response.fee;
        });
    },
    getUserOptions(data) {
      return data.map(({ id, full_name }) => ({ value: id, text: full_name }));
    },
    async fetchData() {
      await this.$http
        .get("/api/v1/transactions/transferCashInMethods/all?name=bank transfer")
        .then((response) => {
          this.cashin_methods_data = response;
        });
    },
  },
};
</script>
